export default "__VITE_ASSET__Bxjp4FAw__"